/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_2_AInputs */

const en_vc_faq_2_a = /** @type {(inputs: Vc_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partly. It opens .ai files saved with PDF compatibility (Illustrator's default) and legacy version 7 .ai files with their layers, groups and type, and it can export PDF-compatible .ai. Illustrator-only editing data is not written, and reliable round trips with complex real-world .ai files are still in progress, so keep your originals.`)
};

const zh_vc_faq_2_a = /** @type {(inputs: Vc_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分可以。以 PDF 兼容方式保存的 .ai 文件（Illustrator 的默认设置）和旧版第 7 版 .ai 文件都能打开，并保留图层、编组和文字；也能导出 PDF 兼容的 .ai。Illustrator 专有的编辑数据不会写回，复杂 .ai 文件的稳定互通还在开发中，请保留好原文件。`)
};

/**
* | output |
* | --- |
* | "Partly. It opens .ai files saved with PDF compatibility (Illustrator's default) and legacy version 7 .ai files with their layers, groups and type, and it can..." |
*
* @param {Vc_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_2_a = /** @type {((inputs?: Vc_Faq_2_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_2_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_2_a(inputs)
	return zh_vc_faq_2_a(inputs)
});
export { vc_faq_2_a as "vc.faq.2.a" }